import { Card, Col, Row, Skeleton, Space } from "antd";
import React, { useContext } from "react";
import { FallbackPageContent } from "~/components/Layout/Fallbacks/FallbackPageContent";
import { userContext } from "~/context/ContextProvider";
import * as APITypes from "~/API";
import "~/components/Layout/Fallbacks/Fallbacks.css";

function SearchSectionSkeleton() {
  return (
    <section style={{ width: "100%" }}>
      <div style={{ marginBottom: 12 }}>
        <Skeleton active title={{ width: "40%" }} paragraph={false} />
        <Skeleton active paragraph={{ rows: 1 }} title={false} />
      </div>
      <Card
        styles={{ body: { padding: 16 } }}
        style={{
          width: "100%",
          background: "#fafafa",
          borderColor: "#f0f0f0",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 8,
            alignItems: "flex-start",
            width: "100%",
          }}
        >
          <Skeleton.Input active size="large" style={{ flex: "1 1 220px" }} />
          <Skeleton.Button active size="large" />
          <Skeleton.Button active size="large" />
        </div>
      </Card>
    </section>
  );
}

function ActionCardSkeleton() {
  return (
    <Card>
      <Skeleton active avatar paragraph={{ rows: 2 }} />
    </Card>
  );
}

function NextStepsSkeleton() {
  return (
    <Card>
      <Skeleton active title paragraph={{ rows: 3 }} />
    </Card>
  );
}

function FinanceCardSkeleton() {
  return (
    <Card style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 16,
        }}
      >
        <Skeleton active title paragraph={{ rows: 1 }} />
        <Skeleton.Button active size="large" />
      </div>
    </Card>
  );
}

function TenantHomePageContentFallback() {
  return (
    <Space direction="vertical" size={24} style={{ width: "100%", marginTop: 8 }}>
      <FinanceCardSkeleton />
      <NextStepsSkeleton />
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <ActionCardSkeleton />
        </Col>
        <Col xs={24} md={12}>
          <ActionCardSkeleton />
        </Col>
      </Row>
      <SearchSectionSkeleton />
    </Space>
  );
}

function NonTenantHomePageContentFallback() {
  return (
    <Space direction="vertical" size={24} style={{ width: "100%", marginTop: 8 }}>
      <SearchSectionSkeleton />
      <NextStepsSkeleton />
      <ActionCardSkeleton />
    </Space>
  );
}

/** Home dashboard skeleton — layout matches tenant vs non-tenant home views. */
export const HomePageContentFallback: React.FC = () => {
  const { status } = useContext(userContext);
  const isActiveTenant = status === APITypes.TenantStatusType.Active;

  return (
    <FallbackPageContent aria-label="Loading home">
      {isActiveTenant ? (
        <TenantHomePageContentFallback />
      ) : (
        <NonTenantHomePageContentFallback />
      )}
    </FallbackPageContent>
  );
};
